var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"styTab"},_vm._l((_vm.btnAllInfo.btnList),function(item,index){return _c('div',{key:index,class:`styTabsame ${
        item.id == _vm.btnAllInfo.isSel ? 'styTabsameActive' : ''
      }`,on:{"click":function($event){return _vm.handleSelBtn(item)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }